export default __webpack_public_path__ + "static/media/List-documentation.5ca16413.md";